<template lang="pug">
div.event-brochure-stack.is-ancestor

    div.brochure-contents.tile.is-parent
        event-card.is-dark(
            role="article"
            v-for="(item, index) in visibleItems" v-bind:key="index"
            v-bind:item="item"
            v-bind:image-as-background="true"
            v-bind:header="false"
            v-bind:social="false")

            div.multimedia-title.event-title

                div.event-period {{ getEventPeriodString(item) }}

                div.event-class-title-icon(
                    v-if="item.EventClass"
                    v-bind:style="getEventClassStyle(item.EventClass)"
                    v-bind:title="$t(`events.eventClass.${item.EventClass}`)")
                    component(
                        v-bind:is="getEventClassIcon(item.EventClass)"
                        title='')

            div.event-info
                router-link(v-bind:to="getRoute(item, null, 'Event')")
                    h4 {{ item.Name }}
                    p.ingress-text(v-html="item.IngressText")
                    button.btn {{ $t('collections.explore') }}


        plus-more(
            v-if="!allVisible"
            v-on:click="onShowAll")


</template>

<script>
import EventsMixin from '@/components/Base/EventsMixin';
import HyperlinkMixin from '@/components/Base/HyperlinkMixin';

export default {
    name: 'event-brochure-stack',

    props: {
        items: {            type: Array[Object], required: true },
        count: {            type: Number, default: 3 },
        offset: {           type: Number, default: 0 },
        showAllRoute: {     type: Object }
    },

    mixins: [ EventsMixin, HyperlinkMixin ],

    data: function () {
        return {
            visibleItems: _.take(this.items.slice(this.offset), this.count),
            allVisible: false
        };
    },

    created: function () {
        this.init();
    },

    watch: {
        items: function () {
            this.init();
        }
    },

    methods: {
        init: function () {
            this.visibleItems = _.take(this.items.slice(this.offset), this.count);
            this.allVisible = (this.visibleItems.length === this.items.length);
        },

        onShowAll: function () {
            this.visibleItems = this.items;
            this.allVisible = true;
        }
    }
};
</script>

<style lang="scss">
// @import '~assets/styles/variables';

.event-brochure-stack {
    .brochure-contents {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        .card {
            flex-basis: auto;
            flex-direction: row;
            flex-grow: 1;
            width: 44vw;
            min-height: 25vh;
            min-height: min-content;
            margin: 0 0 10px;
            padding: 0;
            text-align: center;
            h4 {
                margin-bottom: 1rem;
                padding: 0 2rem;
                font-family: $helvetica-roman;
                font-size: 1.5rem;
                line-height: normal;
            }
            @media screen and (max-width: $breakpoint-tablet - 1) {
                flex-direction: column;
            }
            .card-contents {
                color: $light-gray;
                text-align: center;
                background: black;
            }
            p {
                margin: 1.5rem 0.75rem;
            }
            .dimensions, .owner, .price {
                display: none;
            }
            .event-period {
                color: $light-gray;
            }
            &:first-child {
                width: 100%;
                min-height: 300px;
                margin-top: 0;
                text-align: left;
            }
        }
        .card-image {
            display: flex;
            flex: 1;
            flex-direction: column;
            min-height: 25vh;
            figure {
                margin: 0;
            }
        }
        .multimedia-title.event-title {
            flex-direction: row;
            flex-grow: 1;
            padding: 0.25rem 0.5rem;
            .event-period {
                text-align: left;
            }
            .material-design-icon {
                width: 2rem;
                height: 2rem;
            }
        }
        .event-info {
            flex-grow: 2;
            margin: auto 3rem;
            padding: 0;
            @media screen and (max-width: $breakpoint-mobile - 1) {
                margin: auto 1em;
            }
            // stylelint-disable-next-line no-descending-specificity
            .event-period {
                margin: 0 auto 1.5rem;
                padding-left: 0.5rem;
                font-family: $helvetica-roman;
                font-family: $helvetica-light;
                font-size: 1.15rem;
                color: inherit;
                text-align: left;
            }
            .ingress-text {
                font-family: $helvetica-light;
                font-size: 1rem;
            }
            @media screen and (min-width: $breakpoint-widescreen) {
                h4 {
                    font-size: 2rem; // title
                }
                .ingress-text {
                    margin-top: 3rem;
                    font-size: 1.5rem; // ingress
                }
            }
        }
        .btn {
            margin-bottom: 2rem;
            padding: 9px 15px;
            font-family: $helvetica-bold;
            font-size: 13px;
            background: $light-gray;
            &:hover {
                background: $light-gray-2 !important;
            }
        }
    }
}
</style>
